export enum DataStoreProvisionStatusType {
    Unkown,
    Creating,
    Created,
    Errored
}